export const UPDATE_ORDER = "UPDATE_ORDER";
export const CREATE_ORDER = "CREATE_ORDER";
export const ORDER_FAILED = "ORDER_FAILED";
export const LOAD_ORDER = "LOAD_ORDER";
export const INIT_ORDER = "INIT_ORDER";
export const IS_LOADING = "IS_LOADING";
